<script lang="ts">
	import classNames from 'classnames';
	import dayjs from 'dayjs';
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { NewsRoutes } from '#lib/websites/news/constants/routes.js';
	import { page } from '$app/state';
	import { ChevronRightIcon } from '$global/assets/icons/ChevronRightIcon';
	import { HeniLogoMinimal } from '$global/assets/logos/HeniLogoMinimal';
	import { LinkButton } from '$global/components/LinkButton';
	import { Txt } from '$global/components/Txt';
	import { getPageData } from '$global/utils/getPageData/getPageData';
	import type { NewsDataPageData } from '$routes/news/data/types';

	interface Props {
		showGlobalNav?: boolean;
	}

	let { showGlobalNav }: Props = $props();

	const data = getPageData<NewsDataPageData>(page.data);
	const exclusiveArticles = data.exclusiveArticles;
</script>

<div class="flex h-full flex-col">
	<div class="mt-[-4px] flex items-center gap-4 pb-6">
		<HeniLogoMinimal color="gray-900" class="h-[14px] w-[28px]" />
		<Txt variant="h5">HENI News Exclusives</Txt>
	</div>

	<div class="flex-1 overflow-y-scroll">
		{#each exclusiveArticles as exclusiveArticle, i}
			{@const date = dayjs(
				exclusiveArticle?.publishDate ||
					exclusiveArticle?.date_updated ||
					exclusiveArticle?.date_created
			).format('DD MMM, YYYY @ HH:mm')}

			{#if i > 0}
				<hr />
			{/if}

			<a
				href={`${showGlobalNav ? exclusiveArticle.url : exclusiveArticle.url?.replace(NewsRoutes.Article, NewsRoutes.MobileArticle)}${showGlobalNav ? '' : '?global_nav=0'}`}
				target="_blank"
				rel="noopener noreferrer"
			>
				<Txt class={classNames('line-clamp-2', { 'mt-4': i })} variant="h6"
					>{exclusiveArticle.title}</Txt
				>
				<div class="mt-1 mb-4 text-[10px] text-gray-500">
					{date}
				</div>
			</a>
		{/each}
	</div>

	<div class="flex h-[72px] items-center justify-center">
		<LinkButton
			size="md"
			variant="secondary"
			dataCy="news-data-view-exclusives"
			href={`${GlobalRoutes.NewsHome}?category=exclusives${showGlobalNav ? '' : '&global_nav=0'}`}
			>view exclusives
			{#snippet trailing()}
				<ChevronRightIcon />
			{/snippet}
		</LinkButton>
	</div>
</div>
